import React from 'react'

import LetterLanding from '../LetterLanding';

import logo_target from '../../../images/letterfunnel/helloprint.webp';
import screenshot_target from '../../../images/letterfunnel/hansscheffer.webp';


export default class extends React.Component {

  // variable "competition" is optional, fallback: "jouw B2B concurrenten".
  render() {
    return <LetterLanding
      fullname="Hans Scheffer"
      firstname="Hans"
      companyname="Helloprint"
      competition="Reclameland en Print.com"
      logo_target={logo_target}
      screenshot_target={screenshot_target}
    />;
  }

}



// WEBPACK FOOTER //
// ./src/containers/letterfunnel/landings/hansscheffer.js